import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getPatientAnalyses, 
  getPatientAnalysis,
  clearLocalPatientAnalyses,
  clearLocalActivePatientAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  patientAnalysis: { 
    id: '',  
    result: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    patientAnalysis: false 
  }
};

const slice = createSlice({
  name: 'patientAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getPatientAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getPatientAnalyses.fulfilled, (state, action) => {
        const { patient_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...patient_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getPatientAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getPatientAnalysis.pending, (state) => {
        state.loading.patientAnalysis = true;
      })
      .addCase(getPatientAnalysis.fulfilled, (state, action) => {
        const { data: { patient_analysis }, cable } = action.payload;
        const foundedPatientAnalysis = !!_find(state.all.data, (s) => s.id === patient_analysis.id);
        const updatedPatientAnalysis = { ...state.patientAnalysis, ...patient_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedPatientAnalysis ? _map(state.all.data, (e) => e.id === patient_analysis.id ? { ...e, ...patient_analysis } : e) : [...[patient_analysis], ...oldAllData]; 
        const pagination = foundedPatientAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.patientAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedPatientAnalysis && !cable) state.patientAnalysis = updatedPatientAnalysis;       
      })
      .addCase(getPatientAnalysis.rejected, (state) => {
        state.loading.patientAnalysis = false;
      })
      .addCase(clearLocalPatientAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActivePatientAnalysis, state => {
        state.patientAnalysis = initialState.patientAnalysis;
      })
  }
})

export default slice.reducer;